import { useEffect } from 'react';
import type { ContractTerminationConsequencesResponse } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url: string;
};

type ExecuteProps = {
  url: string;
};

export function useContractTerminationConsequences({ url }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<ContractTerminationConsequencesResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  return request;
}

export type ContractTerminationConsequencesRequest = ReturnType<
  typeof useContractTerminationConsequences
>;
